import React, {Component} from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import {paddingTab, smallTabWidth, largeTabWidth} from './styles.scss';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 0,
    };
  }
  handleClick = (e) => {
    e.preventDefault();
    this.setState({currentTab: parseInt(e.currentTarget.name, 10)});
  };
  render() {
    const {currentTab} = this.state;
    // We filter the items that have content
    const titles = this.props.titles.filter(
      (title, index) => this.props.contents[index],
    );
    const contents = this.props.contents.filter((content) => content);
    return (
      <div className="ph2">
        {titles.length !== 0 && (
          <div className="pv3 ph2 f5 db-ns flex flex-column">
            {titles.map((title, index) => (
              <a
                key={index}
                className={cx('dib pointer pb3 fw6 black mb0-ns mb3', {
                  [`${paddingTab} bb`]: !this.props.isProjectReview,
                  [`${smallTabWidth} pv3 ba b--light-gray`]:
                    this.props.isProjectReview &&
                    !this.props.isSubmissionHistory,
                  [`${largeTabWidth} w-50-ns w-100 pv3 ba b--light-gray`]:
                    this.props.isProjectReview &&
                    this.props.isSubmissionHistory,
                  'bw2 b--blue-light':
                    currentTab === index && !this.props.isProjectReview,
                  'bw1 b--moon-gray black': currentTab !== index,
                  'bg-white':
                    this.props.isProjectReview && currentTab === index,
                  'bg-light-gray':
                    this.props.isProjectReview && currentTab !== index,
                })}
                name={index}
                onClick={this.handleClick}
              >
                {title}
              </a>
            ))}
          </div>
        )}

        {contents[currentTab]}
      </div>
    );
  }
}

Tabs.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.node),
  contents: PropTypes.arrayOf(PropTypes.node),
  isProjectReview: PropTypes.bool,
  isSubmissionHistory: PropTypes.bool,
};

export default Tabs;
